/**
 * @author       esraa.afifi@zumper.com (Esraa Afifi)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  style.ts
 */

import { css } from '@emotion/react'
import { BREAKPOINT_320 } from '@zcode-ui/themes'

export const smallText = css`
  @media (max-width: ${BREAKPOINT_320}) {
    display: inline;
  }

  @media (min-width: 321px) {
    display: none;
  }
`

export const text = css`
  @media (max-width: ${BREAKPOINT_320}) {
    display: none;
  }

  @media (min-width: 321px) {
    display: inline;
  }
`
